/* eslint-disable no-unused-vars */

export default class ProjectionProxy {

    constructor(projectionImpl) {
        this.projectionImpl = projectionImpl
    }

    toWorldZoom(mapZoom) {
        throw new Error("method must be overriden by subclasses.");
    }

    toMapZoom(worldZoom) {
        throw new Error("method must be overriden by subclasses.");
    }

    toWorldOSMTile(osmTile) {
        throw new Error("method must be overriden by subclasses.");
    }

    toMapOSMTile(worldOSMTile) {
        throw new Error("method must be overriden by subclasses.");
    }

    toWorldLocation(mapLocationOrPoint) {
        throw new Error("method must be overriden by subclasses.");
    }

    toMapLocation(worldLocation) {
        throw new Error("method must be overriden by subclasses.");
    }

    canIndexByTile() {
        throw new Error("method must be overriden by subclasses.");
    }

    getWorldTopLeftCornerForMap(mapTopleftCorner, osmZoom) {
        throw new Error("method must be overriden by subclasses.");
    }

    getWorldBottomRightCornerForMap(mapBottomRightCorner, osmZoom) {
        throw new Error("method must be overriden by subclasses.");
    }
}

/* eslint-enable no-unused-vars */